<template>
    <div>
        <div class="grid-box-fc">
            <div class="sp-card">
                <div class="title">订单统计</div>
                <div class="mainNumber">{{element.totalNum}}</div>
                <div class="other">
                    <div>
                        <span class="key">已开单</span>
                        <span class="value">{{element.totalFinish}}</span>
                    </div>
                    <div>
                        <span class="key">未开单</span>
                        <span class="value">{{element.totalNum-element.totalFinish}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">订单总金额(万元)</div>
                <div class="mainNumber">{{element.totalMoney}}</div>
                <div class="other">
                    <div>
                        <span class="key">已收款</span>
                        <span class="value">{{element.totalPay}}</span>
                    </div>
                    <div>
                        <span class="key">未收款</span>
                        <span class="value">{{element.totalNeedPay}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">今日新增订单</div>
                <div class="mainNumber">{{element.totayAdd}}</div>
                <div class="other">
                    <div>
                        <span class="key">订单金额</span>
                        <span class="value">{{element.todayMoney}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
            <div class="sp-card">
                <div class="title">今日订单发货</div>
                <div class="mainNumber">{{element.todaySend}}</div>
                <div class="other">
                    <div>
                        <span class="key">发货金额</span>
                        <span class="value">{{element.todaySendMoney}}</span>
                    </div>
                </div>
                <img class="img" src="../../../assets/p1.png" />
            </div>
        </div>
        <div class="grid-box-sc">
            <div class="sp-card">
                <div id="order1" style="width:100%;height:100%;"></div>
            </div>
            <div class="sp-card">
                <div id="order2" style="width:100%;height:100%;"></div>
            </div>
        </div>
        <div class="grid-box-sc" style="grid-template-columns: 3fr 2fr;">
            <div class="sp-card">
                <div id="order3" style="width:100%;height:100%;"></div>
            </div>
            <div class="sp-card">
                <div id="order4" style="width:100%;height:100%;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            element:{
                totalNum:0,
                totalFinish:0,
                totalMoney:0,
                totalPay:0,
                totalNeedPay:0,
                totayAdd:0,
                todayMoney:0,
                todaySend:0,
                todaySendMoney:0,
            },
            chartList:[null,null,null,null],
            isShowPage:false,
        }
    },
    methods:{
        setResize(){
            this.chartList.forEach(e=>{
                if(e){ e.resize(); }
            })
        },
        init:function(){
            this.isShowPage = true;
            this.getInfo();
            this.getOrderInfo();
            this.getProductSendInfo();
            this.getCustomerOrderInfo();
            this.getStateInfo();
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('order'+(key+1)));
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getCustomerOrderInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.orderStatisticByCust2({page:1,limit:-1,confirmed:1,...obj}).then(res=>{
                let itemList = res.data.data.data;
                let myChart = this.getMyChart(2);
                if(myChart){
                    let option = {
                        legend: {},
                        
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        title:{
                            text:'客户订货发货',
                            left:'left',
                        },
                        grid:{
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '15%',
                            containLabel: true
                        },
                        xAxis: { type: 'category',data:itemList.map(e=>e.cname)},
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（双）',
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                show: true,
                                xAxisIndex: [0],
                                start: 0,
                                end: 100,
                            },
                        ],
                        series: [
                            { type: 'bar',name:'订货数',data:itemList.map(e=>e.sumUnit)},
                            { type: 'bar',name:'发货数',data:itemList.map(e=>e.sumSendedUnit) }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.datestart = this.filterbox.time[0];
                obj.dateend = this.filterbox.time[1];
            }
            this.$api.getListOrder({page:1,limit:1,type:1,...obj}).then(res=>{
                let dd = res.data.data;
                this.element.totalNum = Number.parseInt(res.data.count);
                let totalprice = dd.sumPrice-dd.sumFree;
                this.element.totalPay = Number.parseFloat((dd.sumPay/10000).toFixed(3));
                let needpay = totalprice - dd.sumPay;
                this.element.totalMoney = Number.parseFloat((totalprice/10000).toFixed(3));
                this.element.totalNeedPay = Number.parseFloat((needpay/10000).toFixed(3));
            })
            this.$api.getListOrder({state:4,type:1,page:1,limit:1,...obj}).then(res=>{
                this.element.totalFinish = Number.parseInt(res.data.count);
            })
            let today = this.$common.dayformat(new Date());
            this.$api.getListOrder({type:1,datestart:today,dateend:today}).then(res=>{
                this.element.totayAdd = res.data.count;
                this.element.todayMoney = res.data.data.sumPrice;
            })
            this.$api.listSend({start:today,end:today}).then(res=>{
                this.element.todaySend = res.data.count;
                this.element.todaySendMoney = res.data.data.sumPrice;
            })
            
        },
        getOrderInfo:function(){
            let obj = {
                mode:'',
                start:'',
                end:'',
            }
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }else{
                obj.mode = "month";
            }
            this.$api.orderAmountInfo(obj).then(res=>{
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        title:{
                            text:'订货统计',
                            left:'left',
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        legend: {
                            top: 'top',
                            left:"100px",
                        },
                        grid:{
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '15%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: res.data.data.range,
                        },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（单）',
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                show: true,
                                xAxisIndex: [0],
                                start: 0,
                                end: 100,
                            },
                        ],
                        series: [
                            {
                                name:res.data.data.data[0].name,
                                data: res.data.data.data[0].data,
                                type: 'line',
                                smooth: true,
                                color:'#167FFC',
                            },{
                                name:res.data.data.data[1].name,
                                data: res.data.data.data[1].data,
                                type: 'line',
                                smooth: true,
                                color:'#67C23A',
                            },
                        ]
                    };
                    myChart.setOption(option);
                }   
            })
        },
        getProductSendInfo:function(){
            let obj = {
                sendstate:0,
                confirmed:1,
                notsend:0,
                limit:-1,
                page:1,
                group:'pid',
                column:'sumSendedUnit',
                order:'desc',
            }
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.empOrderStatisticByProd(obj).then(res=>{
                let itemList = [];
                res.data.data.data.forEach(e => {
                    let pid = Number.parseInt(e.pid.split('_')[0]);
                    if(e.sumSendedUnit>0){
                        itemList.push({
                            pid:pid,
                            label:e.pname,
                            count:e.sumSendedUnit,
                        })
                    }
                });
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        color:[
                            '#188BFF',
                        ],
                        legend: {
                            top: 'top',
                        },
                        title:{
                            text:'商品销售统计',
                            left:'left',
                        },
                        grid:{
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '15%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: itemList.map(e=>e.label),
                        },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
                            // name: '单位:（双）',
                        },
                        dataZoom: [
                            {
                                type: 'slider',
                                show: true,
                                xAxisIndex: [0],
                                start: 0,
                                end: 100,
                            },
                        ],
                        series: [
                            {
                                data: itemList.map(e=>e.count),
                                type: 'bar',
                            }
                        ]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getStateInfo:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.getStateOrder(obj).then(res=>{
                let dd = res.data.data;
                let arr = [];
                arr.push({name:'已关闭',value:dd.closed.ordercount});
                arr.push({name:'待确认',value:dd.waitConfirm.ordercount});
                arr.push({name:'已确认',value:dd.confirm.ordercount});
                arr.push({name:'部分发货',value:dd.sendPart.ordercount});
                arr.push({name:'已发货',value:dd.sended.ordercount});
                let myChart = this.getMyChart(3);
                if(myChart){
                    let option = {
                        title:{
                            text:'订单状态',
                            left:'left',
                        },
                        color:[
                            '#e50a2f',
                            '#409eff',
                            '#595bd4',
                            '#ebb563',
                            '#14d3a0',
                        ],
                        tooltip: {
                            trigger: 'item'
                        },
                        legend: {
                            orient: 'vertical',
                            left:'left',
                            bottom:'10px',
                        },
                        series: [{
                            name: '订单状态',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false,
                            },
                            data:arr,
                        }]
                    };
                    myChart.setOption(option);
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.grid-box-fc{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 10px;
    padding-bottom: 10px;
}
.grid-box-sc{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    transition: .25s;
    padding-bottom: 10px;
    height: 340px;
}

</style>